import { useStudio } from './store/studio-store';
import { useAutosave } from './store/use-autosave';
import { useKeyboardShortcuts } from './store/use-keyboard-shortcuts';
import { usePlayback } from './store/use-playback';
import { Canvas } from './ui/Canvas';
import { Diagnostics } from './ui/Diagnostics';
import { Inspector } from './ui/Inspector';
import { Sidebar } from './ui/Sidebar';
import { Timeline } from './ui/Timeline';
import { TopBar } from './ui/TopBar';
import { AssetsPanel } from './ui/panels/AssetsPanel';
import { ProjectPanel } from './ui/panels/ProjectPanel';
import { RenderPanel } from './ui/panels/RenderPanel';
import { ScriptPanel } from './ui/panels/ScriptPanel';
import { StoryboardPanel } from './ui/panels/StoryboardPanel';

export function App() {
  const view = useStudio((s) => s.view);
  const diagnosticsOpen = useStudio((s) => s.diagnosticsOpen);

  usePlayback();
  useKeyboardShortcuts();
  const { clearSavedSession } = useAutosave();

  return (
    <div className="studio">
      <TopBar />
      <div className="studio-body">
        <Sidebar />
        <main className="studio-main">
          {view === 'script' && <ScriptPanel />}
          {view === 'project' && <ProjectPanel />}
          {view === 'assets' && <AssetsPanel />}
          {view === 'storyboard' && <StoryboardPanel />}
          {view === 'render' && <RenderPanel />}
          {view === 'canvas' && <Canvas />}
        </main>
        <Inspector />
      </div>
      <Timeline />
      {diagnosticsOpen && <Diagnostics onClearSession={clearSavedSession} />}
    </div>
  );
}
